module.exports = __webpack_public_path__ + "img/mz.ad65ee8c.png";